import { createAndFireEvent, type CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import type { AnalyticsPayload } from '../types';
import { ANALYTICS_CHANNEL } from './constants';

const createAndFireEventOnPeopleTeams = createAndFireEvent(ANALYTICS_CHANNEL);

/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 *
 * All Invite People analytics should go through this low level function.
 *
 * You can use it in test assertions.
 */
export const fireAnalyticsEvent = (
	payload: AnalyticsPayload,
	createAnalyticsEvent: CreateUIAnalyticsEvent,
) => {
	const fire = createAndFireEventOnPeopleTeams(payload);

	fire(createAnalyticsEvent);
};

/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */
export type FireAnalyticsEvent = typeof fireAnalyticsEvent;
